export const APPLICATION_ALREADY_COMPLETED_MESSAGE = 'Application is already completed.'
